import { render, staticRenderFns } from "./WFCaseQueryConfigEdit.vue?vue&type=template&id=a898ddcc&scoped=true"
import script from "./WFCaseQueryConfigEdit.vue?vue&type=script&lang=js"
export * from "./WFCaseQueryConfigEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a898ddcc",
  null
  
)

export default component.exports